/* eslint-disable indent */
// components
import GridPageAbstract from '../../GridPageAbstract';
import { MenuItem } from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import i18 from '../../../i18';
import { SendSqaure2BulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';

export default class IncomingTransactionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'externalIncomingTransactions';
        this.controllerName = 'externalTransactions';
        this.Server = this.props.context.getState().server.externalTransactions;
        this.exportButton = true;
        this.permissionName = 'approve-external-transaction';

        this.headerStartIcon = SendSqaure2BulkIcon;
        this.getToolbarActions = () => [
            this.allowedAction('approve-external-transaction') &&
                this.needsApproval() && {
                    title: i18.t('buttons.approve'),
                    onClick: () => this.handleApproveDialogOpen()
                }
        ];

        this.baseFilterRequest = [
            {
                field: 'direction',
                op: '=',
                value: 'in'
            }
        ];

        this.searchFields = ['id', 'email', 'wallet.walletNumber'];

        this.hiddenColumns = config?.hiddenColumns?.externalTransactions || [];

        this.Head = [
            {
                id: 'id',
                label: 'id',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'walletAmount',
                label: 'walletAmount',
                alignRight: false,
                cell: 'Amount',
                filterCell: 'Range',
                disableEditor: true
            },
            {
                id: 'paymentAmount',
                label: 'paymentAmount',
                alignRight: false,
                cell: 'Amount',
                filterCell: 'Range',
                disableEditor: true
            },
            {
                id: 'exchangeRate',
                label: 'exchangeRate',
                alignRight: false,
                cell: 'Text'
            },
            { id: 'email', label: 'email', alignRight: false, cell: 'Text' },
            {
                id: 'walletsId',
                searchField: 'wallet.walletNumber',
                label: 'walletNumber',
                alignRight: false,
                cell: 'Associated',
                object: 'wallet',
                searchType: 'server', // server, client
                searchFields: ['walletNumber'], // for server search
                searchController: 'wallets', // for server search
                associatedSettings: { primary: 'walletNumber' },
                display: 'walletNumber',
                from: 'wallets'
            },
            {
                id: 'approvalState',
                label: 'approvalState',
                alignRight: false,
                cell: 'Status',
                items: [
                    'pending',
                    'manual_approved',
                    'auto_approved',
                    'rejected'
                ],
                filterCell: 'Items',
                filterBy: 'approvalState',
                needTranslate: true,
                disableEditor: true
            },
            {
                id: 'paymentGatewaysId',
                searchField: 'paymentGateway.name',
                label: 'paymentGateway',
                alignRight: false,
                cell: 'Associated',
                associatedSettings: { primary: 'name' },
                searchType: 'server', // server, client
                searchFields: ['name'], // for server search
                searchController: 'paymentGateways', // for server search
                from: 'paymentGateways',
                display: 'name',
                object: 'paymentGateway'
            },
            {
                id: 'paymentCurrenciesId',
                searchField: 'paymentCurrency.name',
                label: 'paymentCurrency',
                alignRight: false,
                cell: 'Select',
                from: 'currencies',
                display: 'name',
                object: 'paymentCurrency'
            },
            {
                id: 'direction',
                label: 'direction',
                alignRight: false,
                cell: 'Text',
                defaultValue: 'in',
                hideInEditor: true,
                disableGrid: true
            },
            {
                id: 'gatewayFee',
                label: 'gatewayFee',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'systemFee',
                label: 'systemFee',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((it) => !this.hiddenColumns.includes(it.id));
    }

    needsApproval = () => {
        return this.List.filter((item) =>
            this.state.selected.includes(item.id)
        ).some((item) => item.approvalState === 'pending');
    };

    renderCustomMenuItems() {
        if (!this.allowedAction(this.permissionName)) return null;

        const needsApproval =
            this.List.find((item) => item.id === this.state.menuClickItemId)
                ?.approvalState === 'pending';

        if (!needsApproval) return null;

        return [
            <MenuItem
                key="approve"
                onClick={(event) => this.handleApproveDialogOpen(event)}
                sx={{ color: 'success.main' }}
            >
                <TaskAltIcon sx={{ mr: 2 }} />
                {i18.t('buttons.approve')}
            </MenuItem>
        ];
    }
}
